import {FC} from 'react';
import {shallowEqual} from 'react-redux';
import {useForm} from 'react-hook-form';
import qs from 'qs';
import Media from 'react-media';
import Cookies from 'js-cookie';

import {useSelector} from '~/store/hooks';
import {uploadImageSearch} from '~/services/images';
import {WorkerCookieName} from '~/utils/constants';
import {createSearchForm} from '~/app-header/components/Header/parts/utils';

import MobileSearchHeader from './SearchHeaderContent/MobileSearchHeader';
import DesktopSearchHeader from './SearchHeaderContent/DesktopSearchHeader';

const SearchHeaderContent: FC = () => {
  const isWorker = Boolean(Cookies.get(WorkerCookieName));

  const {impersonate, mail, searchForm, manageMenu} = useSelector(
    ({app}) => ({
      impersonate: app.data.impersonate,
      mail: app.data.mail,
      searchForm: app.data.searchForm,
      manageMenu: app.manageMenu,
    }),
    shallowEqual
  );

  const form = useForm({
    defaultValues: {
      query: searchForm.value,
      utmSource: searchForm.utmSource,
    },
  });

  // upload img & post cdn url
  const uploadFile = async (formData: FormData) => {
    uploadImageSearch(formData)
      .then((res) => {
        // responses form different api`s
        const imgPath = res?.data?.url ?? res?.data?.data?.src ?? null;
        if (imgPath) {
          createSearchForm(imgPath);
        } else {
          console.error(res);
        }
      })
      .catch((err: any) => console.error(err));
  };

  const onSubmit = async (values: any) => {
    const requestValues = {
      q: values.query,
      utmSource: values.utmSource,
    };

    if (values.file) {
      const formData = new FormData();
      formData.append('img', values.file);

      await uploadFile(formData);

      return;
    }

    window.location.href = `${searchForm.searchAction}${qs.stringify(requestValues, {
      encodeValuesOnly: true,
      addQueryPrefix: true,
      skipNulls: true,
    })}`;
  };

  const queries = {
    small: '(max-width: 768px)',
    large: '(min-width: 769px)',
  };

  const props = {
    manageMenu,
    impersonate,
    mail,
    form,
    onSubmit,
    searchForm,
    isWorker,
  };

  return (
    <Media queries={queries}>
      {(matches) => (
        <>
          {matches.small && <MobileSearchHeader {...props} />}
          {matches.large && <DesktopSearchHeader {...props} />}
        </>
      )}
    </Media>
  );
};

export default SearchHeaderContent;
